import Config from './Config';
import resolveConfigActions from './resolveConfigActions';
import StoreName from '../Shared/Constants/StoreName';

const createConfigStore = (state, initialValue) =>
    state.createStore({
        name: StoreName.CONFIG,
        model: Config,
        actions: resolveConfigActions,
        containsNestedProps: true,
    }, initialValue);

export default createConfigStore;
